import Vue from 'vue'
import { upperFirst, camelCase } from 'lodash'
/*  MODIFIED TO IMPORT SUB FOLDERS */

const requireComponent = require.context(
  // The relative path of the components folder
  '/',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)
    // Get PascalCase name of component
    const componentName = upperFirst(
      camelCase(
        // Strip the leading `./` and extension from the filename
        // fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        fileName.replace(/^.*[\\/]/, '').split('.')[0]
      )
    )
    // Register component globally
    Vue.component(
      componentName,
      // Look for the component options on `.default`, which will
      // exist if the component was exported with `export default`,
      // otherwise fall back to module's root.
      componentConfig.default || componentConfig
    )
})
